import { ExpenseRepository } from "@beneficiary/data/repositories/expense.repository";
import { ToastManagerStore } from "@core/presentacion/component/feedback/toast-manager/toast-manager.store";
import { inject, injectable } from "inversify";

@injectable()
export class DeleteExpenseUseCase {
    constructor(
        @inject(ExpenseRepository)
        private readonly expenseRepository: ExpenseRepository,
    ) {}

    async execute(expenseId: number): Promise<boolean> {
        const result = await this.expenseRepository.delete(expenseId);

        if (result.isLeft()) {
            ToastManagerStore.error(result.getLeftOrThrow().message);
        }

        return result.isRight();
    }
}
